export class VenueMaxCapacityModel {
  public venueId: string = '';
  public maxCapacity: number;
}
